import { Typography } from "antd";
import withIntervalRerender from "hocs/withIntervalRerender";
import { DateTime } from "luxon";
import React from "react";
import { getFormatedTimer } from "utils/time";

function TimerCard({ date, warning = false, style = {}, size = 14 }) {
  const formatedTime = getFormatedTimer(DateTime.fromJSDate(date));

  return (
    <Typography.Text
      type={warning ? "warning" : "primary"}
      style={{ textAlign: "center", fontSize: size, ...style }}
    >
      {formatedTime}
    </Typography.Text>
  );
}

export default withIntervalRerender(TimerCard, 1000);
